import React, { useMemo, useRef, useEffect } from 'react';
import GridThead from '../GridThead/GridThead';
import GridTbody from '../GridTbody/GridTbody';
import { StickyTable } from 'react-sticky-table';
import css from './GridTable.module.scss';
import classnames from 'classnames';
import { generateCompStylers } from '../../../../common/utils/styles';
import { useWindowDimensions } from '../../../../common/utils/windowDimensions';
import { useDraggableScroll, useFixedHead } from '../helpers';

const GridTable = ({
    gridName,
    setGridData,
    cellThAddButton,
    viewThead = { data: [] },
    viewData,
    cellWidthArray,
    tableData = { data: [] },
    openSwitcher,
    handlers = {},
    variant,
    gridStyles,
    showThead,
    sticky,
    fullScreen,
    refTable,
    refTableChild,
    translation,
    emptyDataText,
    pageSettings,
    fixedLastColumnShow,
    setIsOverflow,
    isFixedLastColumnShow,
    isFixedColumn,
    maxGridHeight
}) => {
    const thead = useMemo(() => viewThead?.data, [viewThead]);
    const widthArr = useMemo(() => {
        if (cellWidthArray) {
            return thead.map((data, idx) => {
                if (!cellWidthArray[idx]) {
                    return {};
                }
                return {
                    width: `${cellWidthArray[idx]}px`,
                    minWidth: `${cellWidthArray[idx]}px`
                };
            });
        }
        return [cellWidthArray];
    }, [cellWidthArray, thead]);
    const rowRef = useRef();
    const tableRef = useRef();
    const srollTableRef = useRef();

    const windowDimensions = useWindowDimensions();
    useEffect(() => {
        if (setIsOverflow) {
            if (tableRef?.current?.scrollWidth > tableRef?.current?.clientWidth) {
                setIsOverflow(true);
            } else {
                setIsOverflow(false);
            }
        }
    }, [setIsOverflow, windowDimensions, gridName, viewData]);

    useFixedHead(tableRef, refTable, refTableChild, fullScreen, rowRef, sticky, gridStyles, maxGridHeight);
    const theadProps = {
        gridName,
        cellThAddButton,
        thead,
        gridStyles,
        rowRef,
        sticky,
        widthArr,
        pageSettings,
        fixedLastColumnShow,
        isFixedColumn
    };
    const tbodyProps = {
        thead,
        gridStyles,
        setGridData,
        tableData,
        widthArr,
        variant,
        openSwitcher,
        handlers,
        viewData,
        fullScreen,
        sticky,
        refTable,
        gridName,
        refTableChild,
        translation,
        emptyDataText,
        fixedLastColumnShow,
        isFixedLastColumnShow,
        isFixedColumn
    };
    const { stylers, classes } = generateCompStylers(gridStyles?.tableWrapper);
    useDraggableScroll(srollTableRef, tableRef, isFixedColumn);
    if (sticky) {
        return (
            <div
                ref={srollTableRef}
                className={classnames(
                    css.stickyTable,
                    sticky?.leftStickyColumnCount ? 'sticky-table-column-count' : 'sticky-table-no-column-count',
                    classes?.stickyTable
                )}
            >
                <StickyTable
                    wrapperRef={tableRef}
                    leftStickyColumnCount={sticky?.leftStickyColumnCount || 0}
                    borderWidth={sticky?.borderWidth || 'inherit'}
                    stickyHeaderCount={sticky?.stickyHeaderCount || 1}
                    headerZ={1}
                >
                    <GridThead {...theadProps} />
                    <GridTbody {...tbodyProps} />
                </StickyTable>
            </div>
        );
    }
    return (
        <table style={stylers.table} className={classnames(css.grid, classes.table)}>
            {showThead && <GridThead {...theadProps} />}
            <GridTbody {...tbodyProps} />
        </table>
    );
};
export default GridTable;
